const REQUIRED_REGION_COUNTRY = ['US', 'CA', 'MX'];

export const isRequired = (countryCode: string): boolean => {

    return REQUIRED_REGION_COUNTRY.includes(countryCode);
};
